import { Box, Flex, Image, Text } from '@chakra-ui/react'

export const getTypeLabel = (type) => {
  if (type === 'ask') return 'Ask'
  if (type === 'answer') return ''
  if (type === 'functionFilter') return 'Function'
  if (type === 'tagFilter') return 'Tag'
  if (type === 'recurringEventFilter') return 'Recurring Event'
  if (type === 'meeting') return 'Meeting'
  if (type === 'newQuestion') return ''
}

const ListItem = ({option, onClick, isNotClickable}) => {
  const {type, title, isActive} = option

  const renderFormatted = (text) => {
    const textBlocks = text.split('<<<')
    // console.log(textBlocks)
    return textBlocks.map((block, index) => {
      const [blockType, blockContent] = block.split(';;;')
      if (blockType === 'div') {
        return (
          <Text
            mt={2}
            key={`${option.id}-content-${index}`}
            color='#222222'
            fontWeight='500'
            fontSize='16px'
            lineHeight='19px'
            as='div'
            wordBreak='break-word'
          >
            {blockContent}
          </Text>
        )
      }
      if (blockType === 'br') {
        return (
          <Box my={6} flexShrink={0} key={`${option.id}-content-${index}`}  w='full' bg='#E0E0E0' minH='1px' />
        )
      }
      if (blockType === 'ul') {
        return blockContent.split(';;').map((li, liIndex) => (
          <Flex mb={4} key={`${option.id}-content-${index}-${liIndex}`}>
            {/* <Image boxSize={4} mt='1px' mr='8px' color='brandTextBlack' src='/assets/icons/squareBullet.svg' /> */}
            <Text
              key={`${option.id}-content-${index}`}
              color='#222222'
              fontWeight='500'
              fontSize='16px'
              lineHeight='19px'
              as='div'
              wordBreak='break-word'
            >
              •&nbsp;{li.trim()}
            </Text>
          </Flex>
        ))
      }
      if (blockType === 'ol') {
        return blockContent.split(';;').map((li, liIndex) => (
          <Flex mt={4} key={`${option.id}-content-${index}-${liIndex}`}>
            <Text
              key={`${option.id}-content-${index}`}
              color='#222222'
              fontWeight='500'
              fontSize='16px'
              lineHeight='19px'
              as='div'
              wordBreak='break-word'
            >
              {liIndex+1}.&nbsp;{li.trim()}
            </Text>
          </Flex>
        ))
      }
    })
  }

  return (
    <Flex
      mx={2}
      px={4}
      py={title.startsWith('<<<') ? 4 : 0}
      bg={isActive ? '#F5F7F9' : '#FFFFFF'}
      borderRadius='12px'
      cursor={ isNotClickable ? 'default' : 'pointer' }
      flexWrap='wrap'
      onClick={() => onClick()}
      alignItems='center'
    >
      {title.startsWith('<<<') ? renderFormatted(title) : (
        <Text
          color='#222222'
          fontWeight='500'
          fontSize='16px'
          lineHeight='19px'
          as='div'
          wordBreak='break-word'
          my={4}
        >
          {title}
          {option.date && (
            <Text 
              color='#222222'
              fontWeight='500'
              fontSize='16px'
              lineHeight='19px'
              as='span'
              ml={2}
            >
              ({option.date})
            </Text>
          )}
          <Text 
            color='#878A95'
            fontWeight='500'
            fontSize='16px'
            lineHeight='19px'
            as='span'
            ml={2}
          >
            {getTypeLabel(type)}
          </Text>
        </Text>
      )}

      {option.type === 'newQuestion' ? (
        <Flex
          bg='#F5F5F5'
          h='25px'
          w='25px'
          ml='auto'
          px={1}
          alignItems='center'
          justifyContent='center'
          borderRadius='8px'
        >
          <Text
            color='#222222'
            fontWeight='700'
            fontSize='12px'
            lineHeight='16px'
            opacity='0.5'
          >
            N
          </Text>
        </Flex>
      ) : <></>}
      
    </Flex>
  )
}

export default ListItem